import { cn } from '@/lib/utils';
import { getFlagUrl } from '@/shared/assets/flags';

interface CountryFlagProps {
  /** ISO 3166-1 alpha-2 code, e.g. `gb`. */
  country: string;
  className?: string;
}

/** Decorative: always rendered next to text that names what the flag stands for. */
export function CountryFlag({ country, className }: CountryFlagProps) {
  const src = getFlagUrl(country);

  if (!src) {
    return null;
  }

  return <img src={src} alt="" loading="lazy" className={cn('h-4 w-6 shrink-0 rounded-sm object-cover', className)} />;
}
